<template>
<!-- <div></div> -->
    <div class="card card-dashboard-fourteen" style="height:210px" v-loading='loading'>
        <label class="az-content-label">Insurance</label>
        <div class="card-body">
            <div class="row mg-t-15 mg-b-20">
            <div class="col">
                <h4>{{no_insurance}}</h4><label class="lb">{{no_insurance>1||no_insurance===0?"Members":"Member"}}</label>
                <span>{{no_insurance>1||no_insurance===0?"have "+text:"has "+text}}</span>
                
            </div>
            </div>
        </div>
        <div class="card-footer">
            <el-select style="width:120px;margin-right:10px" size='mini' clearable v-model="b" placeholder="Select Brand">
                <el-option v-for="(brand,index) in brands" :key="index" :label="brand[1]" :value="brand"></el-option>
            </el-select>
            <span style="font-size:12px;font-weight:600">
                <el-tooltip v-if="b===''" class="item" effect="dark" content="Select a brand to view the Insurance Details" placement="top">
                    <span class="nav-sub-link"><i class="fa fa-angle-right"></i>Insurance</span>
                </el-tooltip>
                <router-link v-else class="nav-sub-link" :to='{path:"/adviserdashboard/insurance",query:{page:"Insurance"}}'>
                    <i class="fa fa-angle-right"></i>Insurance
                </router-link>
            </span>
        </div>
    </div>
</template>
<script>
export default {
    name:"insurance",
    data(){
        return{
            b:'',
            brands:[],
            no_insurance:'',
            text:'',
            loading:true
        }
    },
    created(){
        this.getInsuranceData();
    },
    watch:{
        b(newVal){
            if(newVal !== ''){
                this.$store.dispatch('select_brand',newVal)
            }
        }
    },
    methods:{
        getInsuranceData: function(){
            const userdetail = JSON.parse(localStorage.getItem('userdetail'));
            this.brands = userdetail['brand_list']
            let brand = localStorage.getItem('brand_code')
            this.$api.bo_api.insurance(brand).then(response =>{
                //get the investments data from response
                this.no_insurance = response.data["no_insurance"]
                this.text="no insurance cover"
                this.loading=false
            })
        }
    }
}
</script>
<style scoped>
.lb{
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 0;
    display: block;
    letter-spacing: .5px;
}
</style>